const fromdata = [{
		inputdata: '',
		title: '经销商类型',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '210px',
		btx: true,
		lablewith: '90px',
		options: [{
			key: "1",
			value: "一级经销商",
		},
		{
			key: "2",
			value: "二级经销商",
		}],
		event: 'jxsType'
	},
	{
		inputdata: '',
		title: '产品线',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '210px',
		btx: true,
		// lablewith: '90px',
		options: []
	},
	{
		inputdata: '',
		title: '年度',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '210px',
		btx: true,
		lablewith: '90px',
		options: []
	
	},
	{
		inputdata: '',
		title: '一级经销商',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'selectautocomplete',  
		width: '210px',
		btx: true,
		lablewith: '90px',
		options: []
	}, 
	{
		inputdata: '',
		title: '二级经销商',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'selectautocompletetow',
		width: '210px',
		btx: true,
		lablewith: '90px',
		options: []
	},
	
]
export default fromdata;
